<template>
  <section class="xiaomi-teasers">
    <ImageTeaser
      v-for="item in content"
      :key="item.title"
      :title="item.title"
      heading-tag="h2"
      class="xiaomi-teasers__image-teaser"
      :class="`xiaomi-teasers__image-teaser--${item.id}`"
      :style="item.style"
      lazy
    >
      <template #bgImage>
        <CdnImage
          class="xiaomi-teasers__banner-image"
          :src="item.image.srcMobile"
          :src-md="item.image.srcDesktop"
          :alt="item.title"
          lazy
          sizes="xs:100vw sm:100vw lg:100vw"
        />
      </template>
      <template #button>
        <LinkButton
          transparent
          tag="nuxt-link"
          :to="item.cta.to"
        >
          {{ item.cta.label }}
        </LinkButton>
      </template>
    </ImageTeaser>
  </section>
</template>

<script setup lang="ts">
import { ImageTeaser, LinkButton } from '@i22-td-smarthome/component-library';
import CdnImage from '@/components/cdn-image.vue';

const content = [
  {
    image: {
      srcMobile:
        '/content/content-images/landingpages/xiaomi/teasers/4c40d5c8d12ced60efcbb7ce20baec20/teaser-smartphones-s@2x.jpg',
      srcDesktop:
        '/content/content-images/landingpages/xiaomi/teasers/9068358f9d7a614ff7998624a4e544cd/teaser-smartphones-l@2x.jpg',
    },
    title: 'Entdecke Topaktuelle Xiaomi Smartphones',
    cta: {
      to: '/xiaomi-smartphones',
      label: 'Zu den Smartphones',
    },
    id: 'smartphones',
  },
  {
    image: {
      srcMobile:
        '/content/content-images/landingpages/xiaomi/teasers/52f965fe3f722d3fe807dafc89b6d707/teaser-zubehoer-s@2x.jpg',
      srcDesktop:
        '/content/content-images/landingpages/xiaomi/teasers/89261f2a89f3fa09fde46171a00fe061/teaser-zubehoer-l@2x.jpg',
    },
    title: 'Entdecke das Gesamte Xiaomi Zubehör',
    cta: {
      to: 'xiaomi-zubehoer',
      label: 'Zum Zubehör',
    },
    id: 'zubehoer',
  },
  {
    image: {
      srcMobile:
        '/content/content-images/landingpages/xiaomi/teasers/8aabc8a123007a7717131e2e93709cd8/teaser-watches-s@2x.jpg',
      srcDesktop:
        '/content/content-images/landingpages/xiaomi/teasers/e49a6636c1ab0cb283b08c410be5cbbd/teaser-watches-l@2x.jpg',
    },
    title: 'Entdecke alle Xiaomi Smartwatches',
    cta: {
      to: '/wearables/smartwatches/_xiaomi',
      label: 'Zu den Smartwatches',
    },
    id: 'smartwatches',
    style: '--container-column-content: 500px',
  },
];
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.xiaomi-teasers {
  display: flex;
  flex-direction: column;
  gap: $grid-base;
  max-width: $mq-xl;
  margin-inline: auto;
  padding-inline: $grid-base;

  @include mq($mq-sm) {
    display: grid;
    gap: 2 * $grid-base;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
  }

  :deep(.image-teaser__background-image--mobile) {
    background-position-x: 50%;

    @include mq($mq-sm) {
      background-position-x: 25%;
    }
  }

  :deep(.image-teaser__background-image--desktop) {
    background-position-x: left;
  }

  :deep(.image-teaser__main) {
    @include mq($mq-sm) {
      max-width: 90%;
    }
    @include mq($mq-md) {
      max-width: calc(50% + 24px);
    }
  }

  &__banner {
    &-image {
      height: 100%;
      :deep(img) {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  &__image-teaser {
    height: 470px;
    padding-top: 4 * $grid-base;

    @include mq($mq-sm) {
      &--smartphones {
        grid-column: 1 / 2;
        grid-row: 1 / 2;

        :deep(img) {
          aspect-ratio: 64 / 47;
          @include mq($mq-md) {
            aspect-ratio: 1280 / 777;
          }
        }
      }

      &--zubehoer {
        grid-column: 2 / 3;
        grid-row: 1 / 2;

        :deep(img) {
          aspect-ratio: 64 / 47;
          @include mq($mq-md) {
            aspect-ratio: 1280 / 777;
          }
        }
      }

      &--smartwatches {
        grid-column: 1 / 3;
        grid-row: 2 / 3;

        :deep(img) {
          aspect-ratio: 64 / 47;
          @include mq($mq-md) {
            aspect-ratio: 640 / 191;
          }
        }
      }
    }

    @include mq($mq-md) {
      height: 383px;
      padding-left: 24px;
      padding-top: 90px;

      &--smartwatches {
        :deep(.image-teaser__main) {
          max-width: 370px;
        }
      }
    }
  }
}
</style>
